var _circle, _path, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTickWithBorder = function SvgTickWithBorder(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1874,
    cy: 12.0002,
    r: 10.7346,
    fill: "#3A2F81",
    stroke: "url(#paint0_linear_1_2)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83155 10.9068C8.75237 10.8267 8.65825 10.7631 8.55461 10.7197C8.45097 10.6763 8.33984 10.654 8.2276 10.654C8.11536 10.654 8.00423 10.6763 7.90059 10.7197C7.79695 10.7631 7.70283 10.8267 7.62365 10.9068C7.54411 10.9866 7.48099 11.0814 7.43792 11.1858C7.39485 11.2903 7.37268 11.4022 7.37268 11.5153C7.37268 11.6284 7.39485 11.7403 7.43792 11.8448C7.48099 11.9492 7.54411 12.044 7.62365 12.1238L10.6944 15.2176L10.7443 15.2678C10.8192 15.3434 10.9081 15.4033 11.006 15.4443C11.104 15.4852 11.209 15.5063 11.315 15.5063C11.421 15.5063 11.526 15.4852 11.6239 15.4443C11.7218 15.4033 11.8108 15.3434 11.8857 15.2678L17.1895 9.92419C17.2646 9.84873 17.3241 9.7591 17.3647 9.66043C17.4053 9.56177 17.4263 9.456 17.4263 9.34919C17.4263 9.24237 17.4053 9.1366 17.3647 9.03794C17.3241 8.93927 17.2646 8.84964 17.1895 8.77418L17.1231 8.70724C17.0482 8.63164 16.9592 8.57166 16.8613 8.53074C16.7634 8.48981 16.6584 8.46875 16.5524 8.46875C16.4463 8.46875 16.3414 8.48981 16.2434 8.53074C16.1455 8.57166 16.0565 8.63164 15.9816 8.70724L11.3138 13.4077L8.83155 10.9068Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2",
    x1: 19.2559,
    y1: -2.67964,
    x2: 11.528,
    y2: 28.8888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12C2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC74FF"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTickWithBorder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tick-with-border.77ea423a.svg";
export { ForwardRef as ReactComponent };